import { utils, WorkBook, writeFile } from 'xlsx';
import { ExcelWorkSheet } from './worksheet';

export function generateExcelWorkBook(
  fileName: string,
  worksheets: ExcelWorkSheet[]
) {
  if (worksheets && worksheets.length) {
    const workbook: WorkBook = utils.book_new();
    worksheets.forEach((ws) => {
      utils.book_append_sheet(workbook, ws.underlyingWorksheet, ws.name);
    });
    writeFile(workbook, `${fileName}.xlsx`);
  }
}
